import { useEffect, useState } from "react";

// Shows the messages lenses send with shell.toast().
export default function Toaster() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let timer;
    const onToast = e => {
      setMessage(e.detail);
      clearTimeout(timer);
      timer = setTimeout(() => setMessage(null), 3600);
    };
    window.addEventListener("pot:toast", onToast);
    return () => {
      window.removeEventListener("pot:toast", onToast);
      clearTimeout(timer);
    };
  }, []);

  return message ? (
    <div className="toast" role="status">
      {message}
    </div>
  ) : null;
}
